// extracted by mini-css-extract-plugin
module.exports = {"container":"homework_container__2Ahg3","title":"homework_title__3tIvl","content":"homework_content__-cFL1"};